/**
 * 个人中心
 */
 <template>
    <div id="app" class="contentMain">
     <!-- 面包屑导航 -->
     <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item>个人中心</el-breadcrumb-item> -->
     </el-breadcrumb>
      <div class="personal-container">
        <div class="personal-left">
           <!-- <div class="demo-basic--circle">
            <div class="block">
              <el-avatar :size="50" :src="userForm.head"></el-avatar>
            </div>
           </div> -->
          
        </div>
        <div class="personal-right">
          <el-tabs v-model="activeName" type="border-card" @tab-click="handleTabClick" style="height: 400px;">
            <el-tab-pane name="basic" label="基本信息">
              <el-descriptions class="margin-top" :column="1" border>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-user"></i>
                      姓名
                    </template>
                    {{ userData.real_name }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-mobile-phone"></i>
                      联系方式
                    </template>
                    {{ userData.mobile }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-help"></i>
                      职位
                    </template>
                    {{ userData.role_name }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-help"></i>
                      部门
                    </template>
                    {{ userData.department_name }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-help"></i>
                      性别
                    </template>
                    {{ userData.sex }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-help"></i>
                      上次登录时间
                    </template>
                    {{ userData.last_login_time }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-help"></i>
                      上次登录IP
                    </template>
                    {{ userData.last_login_ip }}
                  </el-descriptions-item>
              </el-descriptions>
            </el-tab-pane>
            <el-tab-pane name="password" label="修改密码">
              <el-form label-width="80px" :model="pwdForm" ref="pwdForm" :rules="pwdFormRules">
                <el-form-item label="旧密码" prop="oldPwd">
                  <el-input v-model="pwdForm.oldPwd" clearable placeholder="请输入旧密码"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPwdOne">
                  <el-input v-model="pwdForm.newPwdOne" clearable placeholder="请输入新密码"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPwdTwo">
                  <el-input v-model="pwdForm.newPwdTwo" clearable placeholder="请再次输入新密码"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button size="small" type="primary" @click="submitPwdForm('pwdForm')">保存</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm" :rules="infoFormRules">
            <el-form-item label="昵称" prop="name">
               <el-input size="small" v-model="infoForm.name" auto-complete="off" placeholder="请填写账户昵称"></el-input>
            </el-form-item>
            <el-form-item label="面板名称" prop="platform_name">
               <el-input size="small" v-model="infoForm.platform_name" auto-complete="off" placeholder="请填写控制面板名称"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
             <el-input size="small" v-model="infoForm.mobile" auto-complete="off" placeholder="请填写手机号" disabled></el-input>
            </el-form-item>
            <el-form-item label="邮件" prop="email">
              <el-input size="small" v-model="infoForm.email" auto-complete="off" placeholder="请填写邮件"></el-input>
            </el-form-item>
            <el-form-item>
            <el-button size="mini" type="primary" @click="submitInfoForm('infoForm')">保存</el-button>
            <el-button size="mini" @click='closeDialog("infoForm")'>取消</el-button>
            </el-form-item>
      </el-form>
    </el-dialog>

    </div>
</template>

<script>
import { 
  getAdminInfo, 
  resetPassword } from '../../api/crmMG'
import { checkLogin } from '../../utils/util'
import md5 from 'js-md5'
import '../../assets/js/directive'

export default {
    data() {
        return {
            editFormVisible: false,// 控制编辑页面是否显示
            pwdFormVisible: false,// 控制编辑页面是否显示
            bindEmailFormVisible: false,// 控制邮箱绑定页面是否显示
            bindMobileFormVisible: false,// 控制手机绑定页面是否显示
            // mainWidth: this.$refs.main.clientWidth,
            // mainHeight: this.$refs.main.clientHeight,
            title: '',// 弹窗标题
            userData: [],
            userForm: {
              real_name: '',
              platform_name: '',
              email: '',
              mobile: '',
              head: '',
              desc: ''
            },
            infoForm: {
                name : '',
                platform_name : '',
                mobile : '',
                email : '',
            },
            pwdForm: {
                oldPwd: '',
                newPwdOne: '',
                newPwdTwo: ''
            },
            emailForm: {
              email: '',
              emailCode: ''
            },
            mobileForm: {
              mobile: '',
              mobileCode : ''
            },
            // 表单验证
            infoFormRules: {
                 real_name: [{required: true, message: '请输入真实姓名', trigger: 'blur'}],
                 sex: [{required: true, message: '请选中性别', trigger: 'blur'}],
                 mobile: [{required: true, message: '请输入手机号', trigger: 'blur'}],
                 email: [{required: true, message: '请输入邮箱', trigger: 'blur'}],
            },
            pwdFormRules: {
                 pwd: [{required: true, message: '请输入新密码', trigger: 'blur'}],
            },
            activeName: 'basic',
            userFormRules: {
              name: [
                { required: true, message: '账户昵称不能为空', trigger: 'blur' }
              ],
              platform_name: [
                { required: true, message: '面板名称不能为空', trigger: 'blur' }
              ]
            },
            pwdFormRules: {
              oldPwd: [
                { required: true, message: '旧密码不能为空', trigger: 'blur' }
              ],
              newPwdOne: [
                { required: true, message: '新密码不能为空', trigger: 'blur' }
              ],
              newPwdTwo: [
                { required: true, message: '新密码不能为空', trigger: 'blur' }
              ],
            },
            emailFormRules: {
              email: [
                { required: true, message: '邮箱不能为空', trigger: 'blur' },
                {
                  validator: function(rule, value, callback) {
                    if (/^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(value) == false) {
                      callback(new Error("请输入正确的邮箱"));
                    } else {
                      //校验通过
                      callback();
                    }
                  },
                  trigger: "blur"
                }
              ],
              emailCode: [
                { required: true, message: '验证码不能为空', trigger: 'blur' }
              ],
            },
            buttonName: '获取验证码',
            count: 60,
            disable: false

        }
    },
     /**
   * 创建完毕
   */
    created() {
        this.getdata()
    },

    /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取管理员信息
    getdata(){
        const param = {}
        getAdminInfo(param)
        .then(res => {
          res = checkLogin(res)
          if (res.code == 200) {
            this.userData = res.data
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.$message.error('系统错误！')
        })
    },
    submitPwdForm: function(pwdForm){
      this.$refs[pwdForm].validate(valid => {
        if(valid){
          if(this.pwdForm.newPwdOne != this.pwdForm.newPwdTwo){
              this.$message({
                type: 'error',
                message: '新密码两次不一致!'
              })
              return false
          }
          let param = {
            oldPwd: md5(this.pwdForm.oldPwd),
            newPwdOne: md5(this.pwdForm.newPwdOne)
          }
           resetPassword(param)
            .then(res => {
            res = checkLogin(res)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '密码修改成功,即将退出，请重新登录!'
              })
              setTimeout(() => {
                  this.$store.commit('logout', 'false')
                  this.$router.push({ path: '/login' })
                }, 1000)
            } else {
                this.$message({
                type: 'error',
                message: res.msg
                })
            }
            })
        }else{
          return false
        }
      })
    },
    handleTabClick(tab,event){
     console.log(tab.name)
    },
    // 立即绑定邮箱
    handleBindEmail(){
      this.bindEmailFormVisible = true
      // console.log('立即绑定邮箱!')
    },
    handleBindMobile(){
      this.bindMobileFormVisible = true
    },
    getEmailCode(){
      let email = this.emailForm.email
      console.log(email)
      if(!email || email.length < 0){
        this.$message({
          type: 'info',
          message: '邮箱不能为空'
        })
        return false
      }
      let email_reg = /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if(email_reg.test(email) == false){
        this.$message({
          type: 'info',
          message: '请输入正确的邮箱'
        })
        return false
      }
      // 请求后端发送验证码
      getBindEmailCode({email: email})
      .then(res=>{
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.tackBtn()
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    tackBtn(){
      var timeout = setInterval(()=>{
        if(this.count < 1){
          this.disable = false;
          this.buttonName = '获取验证码';
          this.count = 60;
          clearInterval(timeout);
        }else{
          this.disable = true;
          this.buttonName = this.count--+'s后重发';
        }
      },1000)
    },
    // 获取手机验证码
    getMobileCode(){
      let mobile = this.mobileForm.mobile
      console.log(mobile)
      if(!mobile || mobile.length < 0){
        this.$message({
          type: 'info',
          message: '手机号不能为空'
        })
        return false
      }
      let mobile_reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if(mobile_reg.test(mobile) == false){
        this.$message({
          type: 'info',
          message: '请输入正确的手机号'
        })
        return false
      }
      getBindMobileCode({mobile: mobile})
      .then(res=>{
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.tackBtn()
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 绑定邮箱
    saveEmail(){
      let email = this.emailForm.email
      let code = this.emailForm.emailCode
      if(!email || email.length < 0){
        this.$message({
          type: 'info',
          message: '邮箱不能为空'
        })
        return false
      }
      let email_reg = /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if(email_reg.test(email) == false){
        this.$message({
          type: 'info',
          message: '请输入正确的邮箱'
        })
        return false
      }
      if(!code || code.length < 0){
        this.$message({
          type: 'info',
          message: '验证码不能为空'
        })
        return false
      }
      bindEmail({email: email,code: code})
      .then(res=>{
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.getdata()
          this.bindEmailFormVisible = false
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 绑定手机号
    saveMobile(){
      let mobile = this.mobileForm.mobile
      let code = this.mobileForm.mobileCode
      if(!mobile || mobile.length < 0){
        this.$message({
          type: 'info',
          message: '手机号不能为空'
        })
        return false
      }
     let mobile_reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if(mobile_reg.test(mobile) == false){
        this.$message({
          type: 'info',
          message: '请输入正确的手机号'
        })
        return false
      }
      if(!code || code.length < 0){
        this.$message({
          type: 'info',
          message: '验证码不能为空'
        })
        return false
      }
      bindMobile({mobile: mobile,code: code})
      .then(res=>{
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.getdata()
          this.bindMobileFormVisible = false
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
     // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'infoForm') {
        this.editFormVisible = false
      } else if (dialog == 'pwdForm') {
        this.pwdFormVisible = false
      } else if (dialog == 'emailForm') {
        this.bindEmailFormVisible = false
      } else if (dialog == 'mobileForm') {
        this.bindMobileFormVisible = false
      }
    },
  },
  // mounted(){
  //   const oIframe = document.getElementById('show-iframe');
  //   const oApp = document.getElementById('app');
  //   // const deviceWidth = document.getElementById('app').style.width;
  //   // const deviceHeight = document.documentElement.el-amin.height;
  //   console.log('width:'+oApp.style.width+';height:'+oApp.style.height)
  //   oIframe.style.width = oApp.style.width + 'px';
  //   oIframe.style.height = oApp.style.height + 'px';
  //   oIframe.style.zIndex = -99;
  //   oIframe.style.marginLeft = -20;
  //   oIframe.style.marginTop = -877;
  // },
}
</script>
<style>
  /* .el-main {
      background-color: #f0f2f5;
  } */
  .contentMain {
    /* width: 100%;
    height: 100%;
    box-sizing: border-box;
    color: #FFF;
    background-image: url("../../assets/img/content_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%; */
    /* background: #9e9e9e; */
    /* background-image: url("../../assets/img/bg_1.png"); */
    /* position: relative;
    margin: 0 auto;
    max-width: 1680px;
    min-width: 1024px; */
    /* width: 100%;
    height: 100%; */
    /* min-width: 1200px; */
    margin: 0 auto;
    max-width: 1680px;
    min-width: 1024px;
    min-height: 800px;
    box-sizing: border-box;
    /* background-image: url("../../assets/img/bg.png"); */
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
  }
  .personal-container {
    margin: 20px 30px;
    width: 100%;
    /* border: 1px solid #ebeef5; */
    border-radius: 7px;
    display: flex;
  }
  .personal-left {
    width: 45%;
    border: 1px solid #ebeef5;
    min-height: 300px;
    background-image: url("../../assets/img/person-bg.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
  }
  .personal-right {
    width: 50%;
    height: 400px;
    border: 1px solid #ebeef5;
    margin-left: 20px;
    min-height: 300px;
  }
</style>


// WEBPACK FOOTER //
// src/views/crm/personal.vue